export default function createGraphqlError(errors) {
  // eslint-disable-next-line no-param-reassign
  errors.graphqlError = true;

  return errors;
}
